module.exports = __webpack_public_path__ + "img/state5.1a5bf96e.png";